import * as types from "@/redux/types";

export const showSendingLoaderHandler = () => ({ type: types.SHOW_SENDING_LOADER });

export const hideSendingLoaderHandler = () => ({ type: types.HIDE_SENDING_LOADER });
